<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">امتحانات</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت معلومات امتحانات...</p>
      </div>
      <div v-else class="bg_white p-4 rounded-4">
        <div style="height: 3rem" class="d-flex justify-content-evenly align-items-center mb-4">
          <div @click="activeTab = 'retake'" :class="['d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 w-50 text-center cursor-pointer', { 'border_bottom_theme': activeTab === 'retake' }]">
            <p :class="['bold', { 'text_color_theme': activeTab === 'retake', 'text_color_gray': activeTab !== 'retake' }]">امتحانات دوباره ({{ retakeExams.length }})</p>
          </div>
          <div style="width: 1px" class="h-100 bg_gray"></div>
          <div @click="activeTab = 'finished'" :class="['d-flex align-items-center justify-content-center flex-wrap gap-1 py-3 w-50 text-center cursor-pointer', { 'border_bottom_theme': activeTab === 'finished' }]">
            <p :class="['bold', { 'text_color_theme': activeTab === 'finished', 'text_color_gray': activeTab !== 'finished' }]">امتحانات تکمیل شده ({{ passedExams.length }})</p>
          </div>
        </div>
        
        <div v-if="activeTab === 'retake'">
          <div v-if="retakeExams.length === 0" class="text-center text_color_gray py-5">
            امتحانی برای تلاش دوباره وجود ندارد.
          </div>
          <div v-else v-for="exam in retakeExams" :key="exam.lessons_content_id" class="shadow-sm p-3 mb-3 rounded-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-2">
                <p class="bold">{{ exam.lesson_title }}</p>
                <p class="text_color_gray font_normal">{{ exam.content_title }}</p>
              </div>
              <div class="d-flex align-items-center gap-4">
                <p class="text_color_red">{{ exam.score }} از {{ exam.total_score }}</p>
                <img src="@/assets/imgs/edit_pen.svg" class="icon-size-2 cursor-pointer" alt="" @click="goToLesson(exam.lessons_content_id)">
              </div>
            </div>
            <div v-if="exam.teacher_guide" class="bg_box_light_theme p-3 rounded-4 mt-4">
              <p class="font_normal mb-3 bold">رهنمای استاد</p>
              <p class="font_normal">{{ exam.teacher_guide }}</p>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'finished'">
          <div v-if="passedExams.length === 0" class="text-center text_color_gray py-5">
            هنوز هیچ امتحانی را با موفقیت پشت سر نگذاشته‌اید.
          </div>
          <div v-else v-for="exam in passedExams" :key="exam.lessons_content_id" class="shadow-sm p-3 mb-3 rounded-4">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center gap-2">
                <p class="bold">{{ exam.lesson_title }}</p>
                <p class="text_color_gray font_normal">{{ exam.content_title }}</p>
              </div>
              <div class="d-flex align-items-center gap-4">
                <p class="text_color_theme bold">{{ exam.score }} از {{ exam.total_score }}</p>
                <img src="@/assets/imgs/tick.svg" class="icon-size-2" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'ExamsView',
  data() {
    return {
      activeTab: 'retake',
      retakeExams: [],
      passedExams: [],
      loading: false,
    }
  },
  mounted() {
    this.fetchExams();
  },
  methods: {
    async fetchExams() {
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({ user_id: userId });
        const response = await apiClient.post('/exams_list', formData);
        
        if (response.data.status === 'ok' && response.data.data) {
          this.passedExams = response.data.data.passed_exams || [];
          this.retakeExams = response.data.data.retake_exams || [];
        }
      } catch (error) {
        console.error("Error fetching exams list:", error);
      } finally {
        this.loading = false;
      }
    },
    goToLesson(contentId) {
      this.$router.push({ name: 'LessonDetail', params: { id: contentId } });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>